<template>
  <v-main>
    <v-container fluid class="fill-height">
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card class="elevation-12">
            <v-system-bar height="30" color="grey darken-2">
              <span>
                {{$vuetify.lang.t('$vuetify.common.login')}}
              </span>
              <v-spacer/>
              <v-dialog width="240">
                <template v-slot:activator="{on, attrs}">
                  <v-icon v-bind="attrs" v-on="on">mdi-web</v-icon>
                </template>
                <v-card light>
                  <v-list-item two-line v-for="lang in $code('langs')" :key="lang.cd" @click="changeLocale(lang.cd)">
                    <v-list-item-content>
                      <v-list-item-title>{{lang.on}}</v-list-item-title>
                      <v-list-item-subtitle>{{lang.en}}</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action v-if="lang.cd === $vuetify.lang.current">
                      <v-icon color="green">mdi-check-bold</v-icon>
                    </v-list-item-action>
                  </v-list-item>
                </v-card>
              </v-dialog>
            </v-system-bar>
            <v-card-text>
              <div class="logo-container">
                <img src="@/assets/logo.png" />
              </div>
              <div class="mb-4">
                <v-text-field hide-details autocomplete="username" label="ID" v-model="form.username" @keypress.enter="login()"/>
                <v-text-field hide-details autocomplete="current-password" label="PASSWORD" v-model="form.password" type="password" @keypress.enter="login()"/>
              </div>
              <v-alert v-if="!!message" type="error">
                {{message}}
              </v-alert>
              <v-btn tile block large color="primary" :loading="loading" @click="login()">{{$vuetify.lang.t('$vuetify.tvsm.next')}}</v-btn>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
export default {
  methods: {
    async login () {
      this.loading = true
      try {
        let {data} = await this.$http.post('login', this.form)
        if (!data.status) return (this.message = this.$vuetify.lang.t('$vuetify.tvsm.loginfailcode.' + data.reason))
        this.$session.setSession(data.user)
      }
      catch (error) {
        this.message = error.message
      }
      finally {
        this.loading = false
      }
    },
    changeLocale (langCode) {
      this.$vuetify.lang.current = langCode
      this.$moment.locale(langCode)
      localStorage.setItem('locale', langCode)
    }
  },
  data () {
    return {
      form: {
        username: '',
        password: ''
      },
      loading: false,
      message: null
    }
  }
}
</script>

<style lang="scss" scoped>
.logo-container {
  display: flex;
  justify-content: center;

  > img {
    display: block;
    width: 50%; min-width: 120px; max-width: 560px;
  }
}
</style>